export default "__VITE_ASSET__BT9lBYmH__"